<template>
  <div>
    <template v-for="(item,i) in data">
      <el-menu-item v-if="!item.children" :index="item.url" :key="i">
        <i class="icon iconfont" :class="item.icon"></i>
        <span slot="title">{{item['menuName']}}</span>
      </el-menu-item>
      <el-submenu v-else :index="item.url" :key="i">
        <template slot="title">
          <i class="icon iconfont" :class="item.icon"></i>
          <span>{{item['menuName']}}</span>
        </template>
        <aside-item :data="item.children"></aside-item>
      </el-submenu>
    </template>
  </div>
</template>
<script>
  import { baseData } from '@/service/baseData';
  export default {
    name:'asideItem',
    props:['data'],
    data(){
      return {
        baseData:baseData,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/basics/asideItem.vue